import { render } from "./index.vue?vue&type=template&id=c4901aa2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c4901aa2&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4901aa2"],['__file',"src/components/Select/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4901aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4901aa2', __exports__)) {
    console.log('reload')
    api.reload('c4901aa2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c4901aa2&scoped=true", () => {
    console.log('re-render')
    api.rerender('c4901aa2', render)
  })

}


export default __exports__